import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { featuresConfig } from '@/config/features.config'

export const useModalStore = defineStore('modal', () => {
    const state = reactive({
        showModal: false,
        props: {},
    })

    function openModal(props = {}) {
        state.props = props
        state.showModal = true
    }

    // Opens the modal triggered by "Start Free". Honors the closedBeta
    // feature flag: shows the closed-beta message while true, the normal
    // signup flow once it's flipped to false.
    function openStartModal() {
        openModal({ beta: featuresConfig.closedBeta })
    }

    function closeModal() {
        state.showModal = false
        state.props = {}
    }

    function toggleModal() {
        state.showModal = !state.showModal
        if (!state.showModal) {
            state.props = {}
        }
    }

    return {
        state,
        openModal,
        openStartModal,
        closeModal,
        toggleModal,
    }
})
